// src/pages/DogRecognition/index.js
import React, { useState } from "react";
import {
  Upload, Button, Card, message, Typography, Space, Divider, Spin,
  Result, Row, Col, Layout
} from "antd";
import {
  SearchOutlined, ClearOutlined, CameraOutlined, GithubOutlined, InfoCircleOutlined
} from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const API_BASE_URL = "https://api.xizaijianqishu.top";

// 图片上传配置
const uploadProps = {
  name: 'image',
  listType: 'picture-card',
  maxCount: 1,
  showUploadList: false,
  accept: 'image/*',
};

export default function DogRecognition() {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [recognitionResult, setRecognitionResult] = useState(null);

  // 处理图片上传
  const handleImageUpload = async (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageUrl(e.target.result);
      setRecognitionResult(null); // 清除之前的识别结果
    };
    reader.readAsDataURL(file);
    return false; // 阻止自动上传
  };

  // 处理图片识别
  const handleRecognize = async () => {
    if (!imageUrl) {
      message.warning("请先上传一张狗的图片");
      return;
    }

    setLoading(true);
    try {
      // 这里将调用后端图像识别接口
      // 注意：需要将base64图片转换为Blob对象进行上传
      const response = await fetch(`${API_BASE_URL}/api/dog-recognition`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          "Referer": "https://xizaijianqishu.top/dog-recognition",
        },
        body: JSON.stringify({ 
          image: imageUrl
        }),
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setRecognitionResult(data.result);
          message.success("识别成功！");
        } else {
          message.error(data.message || "识别失败");
        }
      } else {
        // 处理HTTP错误
        try {
          const errorData = await response.json();
          message.error(errorData.message || "识别失败");
        } catch (e) {
          message.error("识别失败");
        }
      }
    } catch (error) {
      console.error("图像识别错误:", error);
      message.error("识别失败，请稍后重试");
    } finally {
      setLoading(false);
    }
  };

  // 清空图片和结果
  const handleClear = () => {
    setImageUrl(null);
    setRecognitionResult(null);
  };

  return (
    <Layout style={{ background: 'transparent' }}>
      <Content className="main-wrap" style={{ padding: '20px' }}>
        {/* 项目标题与介绍 */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Title level={1} style={{ color: 'var(--theme-primary)', marginBottom: '16px' }}>
            🐕 狗类图像识别系统
          </Title>
          <Paragraph style={{ maxWidth: '800px', margin: '0 auto', color: 'var(--theme-text)' }}>
            基于深度学习的狗类品种识别系统，支持多种狗类品种的快速精准识别
          </Paragraph>
        </div>

        {/* 项目特点 */}
        <Row gutter={[16, 16]} style={{ marginBottom: '32px' }}>
          <Col xs={24} sm={12} lg={8}>
            <Card 
              hoverable
              style={{ background: 'var(--theme-card-bg)', border: '1px solid var(--theme-card-border)' }}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <div style={{ fontSize: '24px', color: 'var(--theme-primary)' }}>🔍</div>
                <Title level={4} style={{ margin: '8px 0', color: 'var(--theme-text)' }}>高精度识别</Title>
                <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                  支持上百种狗类品种识别，准确率高达98%以上
                </Paragraph>
              </Space>
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <Card 
              hoverable
              style={{ background: 'var(--theme-card-bg)', border: '1px solid var(--theme-card-border)' }}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <div style={{ fontSize: '24px', color: 'var(--theme-primary)' }}>⚡</div>
                <Title level={4} style={{ margin: '8px 0', color: 'var(--theme-text)' }}>实时响应</Title>
                <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                  毫秒级识别速度，提供流畅的用户体验
                </Paragraph>
              </Space>
            </Card>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <Card 
              hoverable
              style={{ background: 'var(--theme-card-bg)', border: '1px solid var(--theme-card-border)' }}
            >
              <Space direction="vertical" style={{ width: '100%' }}>
                <div style={{ fontSize: '24px', color: 'var(--theme-primary)' }}>📱</div>
                <Title level={4} style={{ margin: '8px 0', color: 'var(--theme-text)' }}>多平台支持</Title>
                <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                  支持各种设备上传的图像格式，兼容性强
                </Paragraph>
              </Space>
            </Card>
          </Col>
        </Row>

      <Card
        className="card-glow"
        style={{ marginBottom: "20px" }}
        title="上传狗的图片"
      >
        <Row gutter={[24, 24]} align="middle">
          <Col span={12}>
            <Upload
              {...uploadProps}
              beforeUpload={handleImageUpload}
            >
              {imageUrl ? (
                <div>
                  <img
                    src={imageUrl}
                    alt="狗的图片"
                    style={{ width: '100%', height: 'auto', maxHeight: '300px', objectFit: 'contain' }}
                  />
                </div>
              ) : (
                <div style={{ padding: '40px 0', textAlign: 'center' }}>
                  <CameraOutlined style={{ fontSize: '48px', color: '#1890ff' }} />
                  <p style={{ marginTop: '16px', color: 'var(--theme-text)' }}>点击或拖拽上传</p>
                  <p style={{ color: '#8c8c8c', fontSize: '12px' }}>支持 JPG、PNG 等格式</p>
                </div>
              )}
            </Upload>
          </Col>
          
          <Col span={12}>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Paragraph style={{ color: 'var(--theme-text)' }}>
                上传一张狗的图片，系统将自动识别狗的品种。
              </Paragraph>
              
              <Space direction="horizontal" style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button 
                  icon={<ClearOutlined />} 
                  onClick={handleClear}
                  disabled={!imageUrl}
                >
                  清空
                </Button>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  onClick={handleRecognize}
                  loading={loading}
                  disabled={!imageUrl}
                >
                  开始识别
                </Button>
              </Space>
            </Space>
          </Col>
        </Row>
      </Card>

      {loading ? (
        <Card className="card-glow" style={{ marginBottom: "20px" }}>
          <div style={{ textAlign: "center", padding: "100px" }}>
            <Spin size="large" tip="正在识别狗的信息..." />
          </div>
        </Card>
      ) : recognitionResult ? (
        <Card className="card-glow" title="识别结果">
          <Result
            status="success"
            title="识别完成！"
            subTitle="以下是识别到的狗的信息："
            extra={(
              <div style={{ width: '100%' }}>
                <div style={{ marginBottom: '16px' }}>
                  <strong style={{ color: 'var(--theme-text)' }}>品种：</strong>
                  <span style={{ color: 'var(--theme-text)' }}>{recognitionResult.breed || '未知'}</span>
                </div>
                <div style={{ marginBottom: '16px' }}>
                  <strong style={{ color: 'var(--theme-text)' }}>置信度：</strong>
                  <span style={{ color: 'var(--theme-text)' }}>{(recognitionResult.confidence || 0).toFixed(2)}%</span>
                </div>
              </div>
            )}
          />
        </Card>
      ) : null}

      <Divider />

      <Divider />

      {/* 技术架构 */}
      <Card 
        title="技术架构" 
        style={{ marginBottom: '32px', background: 'var(--theme-card-bg)', border: '1px solid var(--theme-card-border)' }}
        titleStyle={{ color: 'var(--theme-text)' }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <div style={{ 
              padding: '16px', 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '8px', color: 'var(--theme-primary)' }}>🧠</div>
              <Title level={5} style={{ color: 'var(--theme-text)' }}>深度学习模型</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                基于卷积神经网络(CNN)的图像识别模型，经过海量数据训练
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <div style={{ 
              padding: '16px', 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '8px', color: 'var(--theme-primary)' }}>🖼️</div>
              <Title level={5} style={{ color: 'var(--theme-text)' }}>图像预处理</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                智能图像增强和标准化，提高识别准确率
              </Paragraph>
            </div>
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <div style={{ 
              padding: '16px', 
              background: 'rgba(255, 255, 255, 0.05)', 
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '24px', marginBottom: '8px', color: 'var(--theme-primary)' }}>⚡</div>
              <Title level={5} style={{ color: 'var(--theme-text)' }}>实时推理</Title>
              <Paragraph style={{ margin: 0, fontSize: '14px', color: 'var(--theme-text-secondary)' }}>
                高性能推理引擎，确保快速响应和稳定服务
              </Paragraph>
            </div>
          </Col>
        </Row>
      </Card>

      {/* 使用说明 */}
      <Card className="card-glow" style={{ marginBottom: '32px' }}>
        <Title level={4} style={{ marginBottom: "10px", color: "var(--theme-text)" }}>使用说明</Title>
        <Paragraph style={{ color: "var(--theme-text)" }}>
          1. 点击或拖拽上传一张清晰的狗的图片<br />
          2. 点击"开始识别"按钮，系统将自动分析图片<br />
          3. 等待几秒钟后，查看识别结果<br />
          4. 可以点击"清空"按钮上传新的图片重新识别
        </Paragraph>
      </Card>

      {/* 项目链接 */}
      <div style={{ textAlign: 'center' }}>
        <Space wrap>
          <Button 
            type="primary" 
            icon={<GithubOutlined />}
            onClick={() => window.open('https://github.com', '_blank')}
          >
            GitHub仓库
          </Button>
          <Button 
            icon={<InfoCircleOutlined />}
            onClick={() => window.location.href = '/post/1770479963194'}
          >
            项目文档
          </Button>
          <Button 
            onClick={() => window.history.back()}
          >
            返回项目列表
          </Button>
        </Space>
      </div>
    </Content>
  </Layout>
  );
}